export default __webpack_public_path__ + "media/images/icons/icon-arrow-slider-left-ad9d293fd16e84d2b805902c19148bf8.svg";